module.exports = __webpack_public_path__ + "47910de4313c0ad9847794bfad5e7efe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/skateboard-red-s.png
// module id = 2557
// module chunks = 0